import styled from "@emotion/styled"
import { keyframes } from "@emotion/core";

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }

    100%{
        opacity: 1;
    }
`;

const fadeOut = keyframes`
    0% {
        opacity: 1;
    }

    100%{
        opacity: 0;
    }
`;

export const Container = styled.div`
    transition: opacity ${(props) => `${props.transitionDuration}ms`} ease-in-out;
    opacity: 0;
    visibility: ${ props => props.isVisible ? 'visible' : 'hidden'};
    display: flex;
    z-index: ${(props) => props.zIndex};
    transition: visibility ${(props) => `${props.transitionDuration}ms`} ease-in-out;
    &.full-page {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }

    &.is-visible {
        opacity: 1;
    }

    &.fade-in {
        animation: ${fadeIn} ${(props) => `${props.transitionDuration}ms`};
        opacity: 1
    }

    &.fade-out {
        animation: ${fadeOut} ${(props) => `${props.transitionDuration}ms`} ease-out;
        opacity: 0
    }
`;
